import { useTranslation } from 'react-i18next';
import { useAllInfluencerCategoryOptions } from '@anytag/shared-hooks';
import { MultipleSelectorFieldProps, SelectorField } from '@anytag/shared-molecules';
import { InfluencerFormKeys } from '../InfluencerForm';
import { InfluencerSharedKeys } from './types';

export const InfluencerCategoriesField = (
  props: Omit<MultipleSelectorFieldProps<InfluencerFormKeys>, 'name' | 'options' | 'multiple'>
) => {
  const { t } = useTranslation();
  const { allInfluencerCategoryOptions } = useAllInfluencerCategoryOptions();

  return (
    <SelectorField<InfluencerFormKeys>
      hasSelectAll={false}
      title={t('Selector.Influencer Categories')}
      help={t('Tooltip.Influencer Categories')}
      options={allInfluencerCategoryOptions}
      name={InfluencerSharedKeys.categoryIds}
      multiple
      {...props}
    />
  );
};
